import React from "react";
import { Icd10Code } from "../../../../messages/IcdCode";
import { nullToUndefined } from "../../../../utils/nullToUndefined";
import { withDefault } from "../../../../utils/withDefault";
import { IsDefined } from "../../../Generic/IsDefined";
import SearchModalCard from "../../../SearchModal/SearchModalCard/SearchModalCard";
import SearchICDCardResult from "./SearchICDCardResult";

interface Props {
  placeholder?: string;
  value?: string | null;
  hasError: boolean;
  isOpen: boolean;
  icdCodes: Icd10Code[] | null;
  onChange: (newValue: string) => void;
  onSelectIcdCode: (icdCode: Icd10Code) => void;
  onRequestClose: () => void;
}

const SearchICDCard = ({
  placeholder,
  value,
  hasError,
  isOpen,
  icdCodes: _icdCodes,
  onChange,
  onSelectIcdCode,
  onRequestClose,
}: Props) => {
  return (
    <SearchModalCard
      placeholder={placeholder}
      value={nullToUndefined(value)}
      hasError={hasError}
      isOpen={isOpen}
      onChange={onChange}
      onRequestClose={onRequestClose}
    >
      <IsDefined value={_icdCodes}>
        {(icdCodes) => (
          <>
            {icdCodes.map((icdCode) => (
              <SearchICDCardResult
                key={icdCode.id.toString()}
                searchValue={withDefault(value, "")}
                icdCode={icdCode}
                onClick={() => onSelectIcdCode(icdCode)}
              />
            ))}
          </>
        )}
      </IsDefined>
    </SearchModalCard>
  );
};

export default React.memo(SearchICDCard);
